/**
 * Returns the maximum voltage that is allowed based on the given timezone string.
 * @param {string} timezone Timezone of the home/device
 * @returns
 */
const getVoltageLimit = (timezone) => {
    return 253.0
}

export { getVoltageLimit }
